/*
 * decaffeinate suggestions:
 * DS001: Remove Babel/TypeScript constructor workaround
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import LineView from "./LineView";

let ScriptView;

export default (ScriptView = (function() {
    ScriptView = class ScriptView extends Backbone.Marionette.CompositeView {
        constructor(...args) {
            super(...args);
            this.initialize = this.initialize.bind(this);
            this.onRender = this.onRender.bind(this);
            this.resetScrollPosition = this.resetScrollPosition.bind(this);
        }

        static initClass() {
            this.prototype.template = require("./templates/script_view");
            this.prototype.itemView = LineView;
            this.prototype.itemViewContainer = ".lines";
    
            this.prototype.ui = {
                views: ".script-view",
                lines: ".script-view.lines",
                editor: ".script-view.editor"
            };
    
            this.prototype.events = {
                "change .script-view.editor"() {
                    return this.model.set("script", this.ui.editor.val());
                }
            };
        }

        initialize() {
            return this.listenTo(this.model, "change:activeLine", (m, line) => this.resetScrollPosition(line));
        }

        onRender() {
            this.ui.views.css("display", "none");
            this.ui[this.model.get("view")].css("display", "block");
            // eslint-disable-next-line no-settimeout
            return setTimeout( () => {
                this.resetScrollPosition(this.model.get("activeLine"));
                if (this.model.get("view") === "editor") {
                    return this.ui.editor.focus();
                }
            }
            , 0);
        }

        resetScrollPosition(line) {
            if ((line != null) && (line > 0)) {
                const lines = this.$el.find(".lines");
                const lel = lines.find(`li:nth(${line})`);
                if (lel.length) {
                    return lines.animate(
                        {scrollTop: Math.max(0, ((lel.offset().top - lines.offset().top) + lines.scrollTop()) - (lines.height() * 0.4))}
                    , 1);
                }
            }
        }
    };
    ScriptView.initClass();
    return ScriptView;
})());



// WEBPACK FOOTER //
// ./test/it/lib/ScriptView.js